import { useQuery } from '@tanstack/vue-query';
import * as OrderApi from '@/api/orders';
import { queries } from '@/api/queries';
import currentCustomerStore from '@/stores/currentCustomerStore';

const useGetUpcomingSubscriptionOrders = () => {
  const customerStore = currentCustomerStore();
  const enabled = computed(() => !!customerStore.email);

  return useQuery({
    ...queries.orders.upcoming,
    queryFn: async () => {
      const normalizedOrders = await OrderApi.upcomingOrders();

      if (!normalizedOrders?.order) return normalizedOrders;

      const filteredOrders = Object.entries(normalizedOrders.order).reduce(
        (acc, [id, order]) => {
          if (order.relationships.subscription?.data) acc[id] = order;
          return acc;
        },
        {} as typeof normalizedOrders.order
      );

      if (Object.keys(filteredOrders).length === Object.keys(normalizedOrders.order).length) {
        return normalizedOrders;
      }

      return {
        ...normalizedOrders,
        order: filteredOrders,
      };
    },
    enabled,
  });
};

export default useGetUpcomingSubscriptionOrders;
